<template>
  <v-col
    class="details-column"
    :class="isCollapsible ? 'clickable' : ''"
    @click="toggle"
  >
    <span
      v-if="!isVisible"
      class="grey--text"
    >Details...</span>
    <v-row v-else>
      <template v-for="(column, index) of detailsColumns">
        <div :key="`${column.title}__col`">
          <span v-if="column.title">{{ column.title.toLocaleUpperCase() }}</span>
          <template v-for="detail of column.details">
            <v-row
              v-if="detail.value !== undefined || detail.type === 'select'"
              :key="detail.title"
              class="d-flex align-center"
            >
              <span class="grey--text">{{ `${detail.title}:` }}</span>
              <span
                v-if="detail.type === 'select'"
                class="ml-1"
              >
                <v-select
                  v-model="detail.value"
                  :items="detail.items"
                  :item-text="detail.itemText || 'title'"
                  :item-value="detail.itemValue || 'value'"
                  dense
                  hide-details
                  return-object
                  outlined
                  clearable
                  @change="detail.onChange"
                />
              </span>
              <span
                v-else
                class="ml-1"
              >{{ detail.value }}</span>
            </v-row>
          </template>
        </div>

        <v-divider
          v-if="index < detailsColumns.length - 1"
          :key="`${column.title}__divider`"
          vertical
          inset
          class="mx-4"
        />
      </template>
    </v-row>
  </v-col>
</template>

<script>
/**
 * @typedef {Object} Detail
 * @property {string} title
 * @property {string} value
 * @property {string} type
 * @property {any[]} items
 * @property {Function} onChange
 */
/**
 * @typedef {Object} DetailsEntry
 * @property {string} title
 * @property {Detail[]} details
 */

export default {
  props: {
    /** @type {import('vue').PropOptions<DetailsEntry[]>} */
    detailsColumns: {
      type: Array,
      required: true,
    },
    isCollapsible: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isVisible: true,
    };
  },
  methods: {
    toggle() {
      if (this.isCollapsible) {
        this.isVisible = !this.isVisible;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '~variables';
.full-width-column {
  width: 100%;
}

.clickable {
  cursor: pointer;

  &:hover {
    background-color: @white-smoke;
  }
}
</style>
